import { FC, useEffect, useState } from 'react';
import Layout from 'layouts/Layout';
import PageTitle from 'components/PageTitle';
import Panel from 'components/Panel';
import PanelTitle from 'components/PanelTitle';
import Table from 'components/Table';
import { Button } from 'react-bootstrap';
import { RouteComponentProps, useHistory } from 'react-router';
import { show, EducationalBackgroundGroup } from 'libs/apiClient/admin/educationalBackgroundGroups';
import { editEducationalBackgroundGroupsPathCreator } from 'routes/educationalBackgroundGroups/path';
import Forbidden from 'pages/forbidden';

type urlProps = {} & RouteComponentProps<{ id: string }>;
type University = { degree: string, name: string }

const Show: FC<urlProps> = (props: urlProps) => {
  const history = useHistory()
  const [educationalBackgroundGroup, setEducationalBackgroundGroup] = useState<EducationalBackgroundGroup>()
  const [universities, setUniversities] = useState<University[]>();
  const [isForbidden, setIsForbidden] = useState<Boolean>(false);
  const educationalBackgroundGroupId = props.match.params.id

  useEffect(() => {
    const forbiddenCallback = () => { setIsForbidden(true); }

    const setResponseData = (responseData: EducationalBackgroundGroup) => {
      const universityList: University[] = [];
      responseData.universities.forEach((university: University) => {
        if (!universityList.find(item => item.name == university.name)) {
          universityList.push({ name: university.name, degree: university.degree })
        }
      });

      setUniversities(universityList);
      setEducationalBackgroundGroup(responseData);
    }

    show(educationalBackgroundGroupId, setResponseData, forbiddenCallback)
  }, []);

  const Page = () => {
    return (
      <Layout>
        <PageTitle title="学歴グループ詳細" />
        <Panel className='pb-2'>
          <PanelTitle title='基本情報' />
          <p>id: {educationalBackgroundGroup?.id}</p>
          <p>学歴グループ名: {educationalBackgroundGroup?.name}</p>
        </Panel>
        <Panel>
          <PanelTitle title='学校一覧'>
            <Button variant="primary" onClick={() => history.push(editEducationalBackgroundGroupsPathCreator(educationalBackgroundGroupId))}>編集</Button>
          </PanelTitle>
          <Table>
            <thead>
              <tr>
                <th>区分</th>
                <th>学校名</th>
              </tr>
            </thead>
            <tbody>
              {
                universities?.map(university => {
                  return (
                    <tr key={university.name}>
                      <td className="align-middle">{university.degree}</td>
                      <td className="align-middle">{university.name}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Panel>
      </Layout>
    )
  }

  if (isForbidden) {
    return <Forbidden />
  } else {
    return Page();
  }
}

export default Show;